import {ReactNode} from "react";
import EditTicketExtra from "@CheckOrder/components/EditTicketExtra";

interface EditAmenitiesCtaProps {
    title: string,
    openEditScreen: () => void,
    removeSelectedAmenities: () => void,
    children: ReactNode,
    isUpdating: boolean
}

function EditAmenitiesCta(props: EditAmenitiesCtaProps) {
    const {
        title,
        openEditScreen,
        removeSelectedAmenities,
        children,
        isUpdating,
    } = props

    return (
        <div
            className="gb--card ticket-amenities__edit"
        >
            <EditTicketExtra
                title={title}
                edit={openEditScreen}
                remove={removeSelectedAmenities}
            />
            {children}
        </div>
    )
}

export default EditAmenitiesCta